import {
  Box,
  Container
} from "@mui/material";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import CustomTabPanel from "../components/TabPanel/CustomTabPanel";
import StyledTab from "../components/TabPanel/StyledTab";
import StyledTabs from "../components/TabPanel/StyledTabs";
import DataTable from "./DataTable";

export default function Data({ userInfo }) {
  const [value, setValue] = useState(0);

  const intl = useIntl();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container>
      <h3><FormattedMessage id="Data.heading" /></h3>
      <Box xs={{ width: '100%' }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="style data tabs"
        >
          <StyledTab label={intl.formatMessage({ id: "Data.myData" })} />
          {userInfo?.isAdmin && <StyledTab label={intl.formatMessage({ id: "Data.allData" })} />}
          {userInfo?.isAdmin && <StyledTab label={intl.formatMessage({ id: "Data.trash" })} />}
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        <DataTable userInfo={userInfo} trash={false} all={false} multiSelectEnabled={true} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1} >
        <DataTable userInfo={userInfo} trash={false} all={true} multiSelectEnabled={true} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2} >
        <DataTable userInfo={userInfo} trash={true} all={false} multiSelectEnabled={true} />
      </CustomTabPanel>
    </Container>
  );
}
